// extracted by mini-css-extract-plugin
export default {"labelDay":"style_labelDay__plrQR","days":"style_days__HNDkt"};